module.exports = __webpack_public_path__ + "img/tech.ef5e2ea.png";